<template>
  <Row>
    <Col span="24">
    <div class="preferences-list">
      <i-form inline>
        <Row
            v-for="(item, index) in values"
            :key="item.name || index"
        >
          <Col span="4">
            <Form-item :label="$t('pages_products_components_preferences_edit_index_767')">
              {{ item.name }}
            </Form-item>
          </Col>
          <Col span="16">
            <Form-item :label="$t('pages_products_components_prefer_edit_form_761')">
              <preferences-values v-model="item.values" @input="updateData"/>
            </Form-item>
          </Col>
          <Col span="4" class="handles">
            <Icon type="ios-remove-circle-outline" color="#f30" @click="handleDelete(item.name)"/>
          </Col>
        </Row>
        <Row>
          <Col span="4">
            <Form-item :label="$t('pages_products_components_preferences_edit_index_767')">
              <Input v-model.trim="preName" size="small" />
            </Form-item>
          </Col>
          <Col span="16">
            <Form-item :label="$t('pages_products_components_prefer_edit_form_761')">
              <preferences-values v-model="preValues" @input="updateData"/>
            </Form-item>
          </Col>
          <Col span="4" class="handles">
            <Button type="success" long @click="handleAdd">{{$t('pages_products_components_preferences_edit_index_768')}}</Button>
          </Col>
        </Row>
      </i-form>
    </div>
    </Col>
  </Row>
</template>

<script>
import i18n from '../../../../locales/index'

import PreferencesValues from './preferences-values'
import { preferencesValidate } from '@/libs/validate'
import { isEqual } from 'lodash'
export default {
  name: 'PreferencesEdit',
  components: {
    PreferencesValues
  },
  props: ['value'],
  data () {
    return {
      values: [],
      preName: '',
      preValues: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (isEqual(val, this.values)) return;
        this.values = val || [];
      },
    },
  },
  methods: {
    handleAdd () {
      preferencesValidate({
        preName: this.preName,
        preValues: this.preValues,
        values: this.values
      }).then(() => {
        this.values.push({
          name: this.preName,
          values: this.preValues,
        });
        this.updateData();
        this.preName = '';
        this.preValues = ''; // 清除属性当前input值特殊处理
      })
    },
    handleDelete (name) {
      const index = this.values.findIndex(item => item.name === name);
      this.values.splice(index, 1);
      this.updateData();
    },
    updateData () {
      this.$emit('input', this.values);
    }
  }
}
</script>
<style lang='scss' scoped>
.preferences-list {
    float: left;
    width: 100%;
    background: #f5f5f5;
    border-radius: 5px;
    padding: 12px 20px;
    .handles {
      font-size: 25px;
      margin-top: 30px;
      i {
        cursor: pointer;
        margin-left: 5px;
      }
    }
}
</style>
